import React from 'react'
import {
	InputWrapper,
	Label,
	InputContainer,
	StyledInput,
	InputIconLeft,
	InputIconRight,
	ErrorMessage,
	HelperText,
	TextAreaContent
} from './styled'

const Input = ({
	label,
	error,
	helperText,
	type = 'text',
	placeholder,
	value,
	onChange,
	isTextArea = false,
	disabled = false,
	required = false,
	id,
	name,
	marginBottom,
	fullWidth = false,
	startAdornment,
	endAdornment,
	icon,
	iconPosition = 'left',
	...props
}) => {
	const inputId = id || name || `input-${Math.random()}`

	const hasCompatIcon = !!icon
	const leftNode = startAdornment && (hasCompatIcon && iconPosition === 'left' ? icon : null)
	const rightNode = endAdornment && (hasCompatIcon && iconPosition === 'right' ? icon : null)

	const hasLeft = !!leftNode
	const hasRight = !!rightNode

	return (
		<InputWrapper $mb={marginBottom}>
			{label && (
				<Label htmlFor={inputId}>
					{label}
					{required && <span className="req">*</span>}
				</Label>
			)}
			<InputContainer>
				{hasLeft && (
					<InputIconLeft>{typeof leftNode === 'function' ? leftNode() : leftNode}</InputIconLeft>
				)}
				{!isTextArea ? (
					<StyledInput
						id={inputId}
						name={name}
						type={type}
						placeholder={placeholder}
						value={value}
						onChange={onChange}
						disabled={disabled}
						$error={!!error}
						$hasLeft={hasLeft}
						$hasRight={hasRight}
						style={fullWidth ? { maxWidth: '100%' } : {}}
						{...props}
					/>
				) : (
					<TextAreaContent
						id={inputId}
						name={name}
						type={type}
						placeholder={placeholder}
						value={value}
						onChange={onChange}
						disabled={disabled}
						$error={!!error}
						$hasLeft={hasLeft}
						$hasRight={hasRight}
						style={fullWidth ? { maxWidth: '100%' } : {}}
						{...props}
					/>
				)}

				{hasRight && (
					<InputIconRight>
						{typeof rightNode === 'function' ? rightNode() : rightNode}
					</InputIconRight>
				)}
			</InputContainer>
			{error ? (
				<ErrorMessage>{error}</ErrorMessage>
			) : helperText ? (
				<HelperText>{helperText}</HelperText>
			) : null}
		</InputWrapper>
	)
}

export default Input
